export namespace DisplaysteuerungConstants {
    export const BOUNDED_CONTEXT_NAME = 'Displaysteuerung';
    export const DISPLAYSTEUERUNG_LIZENZ_MODUL = 'displaysteuerung';
    
}

